import { useScrollAnimation } from "@/hooks/useScrollAnimation";
import { cn } from "@/lib/utils";
import { Quote } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";
import testimonialImage from "@/assets/testimonial-duri-campell.png";

const CaseStudyQuote = () => {
  const { ref, isVisible } = useScrollAnimation();
  const { t } = useLanguage();
  const p = "caseStudyBgeh.quote";
  return (
    <section ref={ref as React.RefObject<HTMLElement>} className={cn("py-16 md:py-24 transition-all duration-700", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-secondary/50 to-secondary/30 rounded-3xl p-8 md:p-12 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-32 h-32 bg-chathero-mint/10 rounded-full blur-2xl" />
            <div className="absolute bottom-0 left-0 w-24 h-24 bg-chathero-orange/10 rounded-full blur-2xl" />
            <div className="relative z-10">
              <Quote className="w-12 h-12 text-chathero-mint/30 mb-6" />
              <blockquote className="text-xl md:text-2xl font-medium text-primary leading-relaxed mb-8">"{t(`${p}.text`)}"</blockquote>
              <div className="flex items-center gap-4">
                <img src={testimonialImage} alt={t(`${p}.author`)} className="w-14 h-14 rounded-full object-cover" />
                <div>
                  <div className="font-bold text-primary">{t(`${p}.author`)}</div>
                  <div className="text-sm text-muted-foreground">{t(`${p}.role`)}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default CaseStudyQuote;
